import { Avatar, EditorInput, styled } from '@arpeggi/ui'
import { InfiniteScroll } from '../../infinite-scroll'

const StyledInfiniteScroll = styled(InfiniteScroll.Root, {
  display: 'flex',
  flexDirection: 'column',
  gap: '36px',
  overflow: 'visible'
})

const StyledEditorInput = styled(EditorInput, {
  width: '100%',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '$gray0400',
  backgroundColor: '$white',
  borderRadius: '$8'
})

const CreateCommentContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  gap: '16px',
  alignItems: 'end'
})

const CommentCardContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '@tablet': {
    flexDirection: 'row'
  }
})

const StyledAvatar = styled(Avatar, {
  width: '60px',
  minWidth: '60px'
})

const CommentCardDisplayName = styled('div', {
  color: '#B4C8D3',
  fontWeight: '$semibold',
  fontSize: '$14'
})

export const Comments = {
  InfiniteScroll: StyledInfiniteScroll,
  CreateCommentEditor: StyledEditorInput,
  CreateCommentContainer,
  CommentCardContainer,
  Avatar: StyledAvatar,
  CommentCardDisplayName
}
